var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line/book-open-outline",
    clipPath: "url(#clip0_3165_70860)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book-open"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5257 4.33663L20.5271 4.33769C20.6272 4.41685 20.7083 4.51756 20.7642 4.63234C20.8201 4.747 20.8494 4.87276 20.8501 5.0003C20.8501 5.00043 20.8501 5.00056 20.8501 5.00069L20.8501 17.2H20.85L20.8501 17.2037C20.8549 17.4002 20.7915 17.5922 20.6706 17.7472C20.5497 17.9022 20.3789 18.0105 20.1871 18.0537C20.1871 18.0537 20.1871 18.0537 20.1871 18.0537L12.2034 19.85H11.7967L3.81301 18.0537C3.813 18.0537 3.81299 18.0537 3.81298 18.0537C3.62125 18.0105 3.45041 17.9022 3.32953 17.7472C3.20865 17.5922 3.14521 17.4002 3.15001 17.2037L3.15006 17.2037V17.2V5H3.1501L3.15001 4.99632C3.14684 4.86706 3.17319 4.73878 3.22706 4.62125C3.28094 4.50371 3.36092 4.40001 3.46092 4.31805C3.56091 4.23609 3.67829 4.17801 3.80411 4.14825C3.9299 4.1185 4.06081 4.11783 4.1869 4.14629C4.18694 4.1463 4.18697 4.14631 4.18701 4.14632L11.9668 5.91626L11.9999 5.92379L12.033 5.91635L19.8117 4.16662C19.8119 4.16658 19.8121 4.16654 19.8123 4.1665C19.9363 4.13982 20.0646 4.14121 20.188 4.17059C20.3116 4.2 20.427 4.25674 20.5257 4.33663ZM5.03298 6.10366L4.85006 6.0625V6.25V16.4V16.52L4.96713 16.5463L10.9671 17.8963L11.1501 17.9375V17.75V7.6V7.48L11.033 7.45366L5.03298 6.10366ZM19.033 16.5463L19.1501 16.52V16.4V6.25V6.0625L18.9671 6.10366L12.9671 7.45366L12.8501 7.48V7.6V17.75V17.9375L13.033 17.8963L19.033 16.5463Z",
    fill: "#46474C",
    stroke: "white",
    strokeWidth: 0.3
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3165_70860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuQuestion);
export default __webpack_public_path__ + "static/media/icon_menu_question.1210d19a18e25547a1d2115fcd1bc13c.svg";
export { ForwardRef as ReactComponent };